<script>
import { cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";

export default {
    props: {
        modalTitle: String,
    },
    data() {
        return {
            submitted: false,
            form: {
                id: 0,
                category: "",
            },
        };
    },
    validations: {
        form: {
            category: { required },
        },
    },
    methods: {
        putData(data) {
            this.$v.$reset();
            this.form = cloneDeep(data);
        },
        onReset() {
            this.form = {
                id: 0,
                category: "",
            };
            this.$v.$reset();
            this.submitted = false;
        },
        onCreate() {
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) {
                return;
            }
            this.$emit('dropData', this.form);
        },
    },
};
</script>

<template>
    <div>
        <b-modal
            id="sl-type-category-modal"
            :title="modalTitle"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <form
                @submit.prevent="onCreate"
                class="needs-validation"
                ref="categoryForm"
            >
                <div class="mb-3">
                    <label for="category">
                        SL Category Name
                    </label>
                    <input
                        autocomplete="off"
                        id="category"
                        type="text"
                        v-model="form.category"
                        placeholder="Enter SL Category Name..."
                        class="form-control"
                        :class="{
                            'is-invalid': submitted && $v.form.category.$error,
                        }"
                    />
                    <div
                        v-if="submitted && $v.form.category.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.form.category.required">
                            This field is required.
                        </span>
                    </div>
                </div>

                <div class="modal-footer">
                    <button
                        type="submit"
                        class="btn btn-primary"
                    >
                        Save changes
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('sl-type-category-modal')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
    </div>
</template>
